import React, { Component } from 'react';
import './CheckboxAndInput.css';

class CheckboxAndInput extends Component {


	constructor(props) {
		super(props);

		this.passArrayOfCheckedValues = this.passArrayOfCheckedValues.bind(this);
	}

	passArrayOfCheckedValues() {
		//return only items that are checked
		let checkedItems = [];
		var type = this.props.keyName;
		var accId = localStorage.getItem('accountId');
		this.checkBoxes.forEach((check, i) => {
			if (check.checked) {
				let temp = {};
				temp[type] = check.value;
				temp.value = this.inputEls[i].value;
				temp.AccountId = accId;
				if (check.RoomDetailId || check.AssetDetailId) {//means we're editing an existing one          
					temp.Id = check.RoomDetailId || check.AssetDetailId;
				}
				checkedItems.push(temp);
			}
		});

		this.props.onChange(checkedItems);
	}
	componentWillReceiveProps(newProps) {


		if (newProps.state) {
			this.checkBoxes.forEach((check, i) => {
				newProps.state.forEach((roomDetail) => {
					if (check.value === roomDetail.RoomDetailTypeId) {
						check.checked = true;
						this.inputEls[i].value = roomDetail.Value;
						//add the ID for the update roomdetailId
						check.RoomDetailId = roomDetail.Id;
					}
				});
			});
		}
	}
	componentDidUpdate() {
		//means we're getting some selected room details
		if (this.props.state) {
			this.checkBoxes.forEach((check, i) => {
				this.props.state.forEach((roomDetail) => {

					if (parseInt(check.value, 10) === roomDetail.RoomDetailTypeId) {
						check.checked = true;
						this.inputEls[i].value = roomDetail.Value;
						//add the ID for the update roomdetailId
						check.RoomDetailId = roomDetail.Id;
					} else if (parseInt(check.value, 10) === roomDetail.AssetDetailTypeId) {
						check.checked = true;
						this.inputEls[i].value = roomDetail.Value;
						//add the ID for the update roomdetailId
						check.AssetDetailId = roomDetail.Id;
						//Have to add accountId
						check.AccountId = roomDetail.AccountId;
					}
				});
			});
		}
	}
	render() {
		this.checkBoxes = [];
		this.inputEls = [];
		return (
			<div className="detailAndValue">
				{
					this.props.items ?
						this.props.items.map((item, i) => {
							return (
								<div key={i}>
									<input
										type="checkbox"
										value={item.id}
										ref={el => el ? this.checkBoxes.push(el) : ""}
										onChange={this.passArrayOfCheckedValues}
										name="rdName"
										disabled={!item.valueIsEditable && this.props.disableNotEditable}
									/>
									<p>{item.name}</p>
									<input
										type="text"
										ref={el => el ? this.inputEls.push(el) : ""}
										onChange={this.passArrayOfCheckedValues}
										name="rdValue"
										disabled={!item.valueIsEditable && this.props.disableNotEditable}
									/>
								</div>
							);
						})
						:
						<div>No Options</div>
				}
			</div>
		);
	}

}

export default CheckboxAndInput;




// WEBPACK FOOTER //
// ./src/Components/CheckboxAndInput/CheckboxAndInput.js